import {useEffect, useState} from 'react'
import apiClient from 'src/services/apiClient'

// "Cambia portale" only makes sense when the user is active on more than one program: with a
// single program there is nowhere else to go. Programs are fetched only when `enabled`, so PSPs
// that don't expose the entry don't pay for the extra call.
export function useHasMultiplePrograms (enabled: boolean): boolean {
  const [hasMultiplePrograms, setHasMultiplePrograms] = useState(false)

  useEffect(() => {
    if (!enabled) {
      setHasMultiplePrograms(false)
      return
    }
    let cancelled = false
    apiClient.getPrograms()
      .then((programs: unknown) => {
        if (!cancelled) setHasMultiplePrograms(Array.isArray(programs) && programs.length > 1)
      })
      .catch(() => {
        if (!cancelled) setHasMultiplePrograms(false)
      })
    return () => {
      cancelled = true
    }
  }, [enabled])

  return hasMultiplePrograms
}
